import page from './page.json'

const en = {
  page
}

export default en;